/* Input park: the cell editor converts with the Table round (component-map.md). */
import { FormControl, FormLabel, Input, Stack } from '@chakra-ui/react';
import { Card } from '@main/complykit/components/card';
import { Content } from '@main/complykit/components/slots';
import * as tp from '@main/shared/utils/timeperiod';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Select } from '../combobox';

export type TimeBoundaryRelativeProps = {
  value: tp.TimeBoundaryRelative;
  onChange: (value: tp.TimeBoundaryRelative) => void;
  isDisabled?: boolean;
};

export const TimeBoundaryRelative = ({
  value,
  onChange,
  isDisabled,
}: TimeBoundaryRelativeProps) => {
  const { t } = useTranslation('ui');
  const [offsetInput, setOffsetInput] = useState(value.offset.toString());

  useEffect(() => {
    setOffsetInput(value.offset.toString());
  }, [value.offset]);

  const periodUnitOptions = useMemo(() => {
    return Object.values(tp.TimePeriodUnit).map((value) => ({
      value,
      label: t(`timePeriod.periodUnit.${value}`),
    }));
  }, [t]);

  const periodAlignmentOptions = useMemo(() => {
    return Object.values(tp.TimePeriodAlignment).map((value) => ({
      value,
      label: t(`timePeriod.periodAlignment.${value}`),
    }));
  }, [t]);

  return (
    <Card>
      <Content>
        <Stack>
          <FormControl>
            <FormLabel>{t('timePeriod.unitLbl')}</FormLabel>
            <Select
              value={periodUnitOptions.find((option) => option.value === value.unit)}
              options={periodUnitOptions}
              onChange={(periodUnit) => {
                if (periodUnit) {
                  onChange({ ...value, unit: periodUnit.value });
                }
              }}
              useBasicStyles
              isRequired
              isDisabled={isDisabled}
            />
          </FormControl>
          <FormControl>
            <FormLabel>{t('timePeriod.offsetLbl')}</FormLabel>
            <Input
              value={offsetInput}
              onChange={(event) => setOffsetInput(event.target.value)}
              onBlur={(event) => {
                const offsetInt = parseInt(event.target.value);
                const offset = isNaN(offsetInt) ? value.offset : offsetInt;
                setOffsetInput(offset.toString());
                if (offset !== value.offset) {
                  onChange({ ...value, offset });
                }
              }}
              isRequired
              isDisabled={isDisabled}
            />
          </FormControl>
          <FormControl>
            <FormLabel>{t('timePeriod.alignmentLbl')}</FormLabel>
            <Select
              value={periodAlignmentOptions.find((option) => option.value === value.alignment)}
              options={periodAlignmentOptions}
              onChange={(periodAlignment) => {
                if (periodAlignment) {
                  onChange({ ...value, alignment: periodAlignment.value });
                }
              }}
              useBasicStyles
              isRequired
              isDisabled={isDisabled}
            />
          </FormControl>
        </Stack>
      </Content>
    </Card>
  );
};
